<!-- <div class="container-fluid"> -->
<div [ngClass]="!theme ? 'theme-class' : ''">
    <div class="container">
        <h1 class="fw-600 text-gray my-site-section pt-3">My Sites</h1>
        <div class="col-12 d-flex justify-content-between align-items-center">
            <div class="col-3 ps-0">
                <!-- <label class="fw-600 text-gray my-site-section">My Sites</label><br> -->
                <mat-form-field appearance="outline" class="w-100 country-input flag-input"
                    [ngClass]="theme ? '': 'dark-input' ">
                    <mat-select [(ngModel)]="selected" (selectionChange)="changeData($event)"
                        panelClass="{{selectMenu}}">
                        <mat-option *ngFor="let site of siteData" [value]="site.siteUrl">{{site.siteUrl}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="d-flex align-items-center">
                <div class="date-div" (click)="openDialog()" role="button">
                    <p class="p-0 m-0">Date:{{dateValue}} <i class="bi bi-pencil-fill ms-2"></i></p>
                </div>
                <ng-container *ngIf="activeQuaries.length > 0">
                    <div *ngFor="let query of activeQuaries;let i = index" role="button">
                        <div class="date-div ms-2 d-flex">
                            <div class="" role="button" (click)="selectFilters(i)">
                                <p class="p-0 m-0">{{query.query}} : {{query.name}}</p>
                            </div>
                            <i class="bi bi-x-lg ms-2 fw-bold" (click)="deleteFilter(i)"></i>
                        </div>
                    </div>
                </ng-container>
                <div class="date-div ms-2" [matMenuTriggerFor]="menu" role="button">
                    <p class="p-0 m-0">New <i class="bi bi-plus-lg ms-2 fw-bold"></i></p>
                </div>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="openFilterDialog('QUERY')">Query</button>
                    <button mat-menu-item (click)="openFilterDialog('PAGE')">Page</button>
                    <button mat-menu-item (click)="openFilterDialog('COUNTRY')">Country</button>
                    <button mat-menu-item (click)="openFilterDialog('DEVICE')">Device</button>
                </mat-menu>
            </div>
        </div>
    </div>
    <div class="container mt-3">
        <p class="fw-bold mt-3 my-site-section ">Dashboard</p>
        <div class="row">
            <div class="col-md-3">
                <div class="card text-start" role="button" (click)="totalClicks =! totalClicks;showChart()"
                    [ngClass]="!!totalClicks ? 'active-click border-0' : ''">
                    <div class="card-body">
                        <div class="d-flex justify-content-between">
                            <h5 class="card-title fw-bold fs-6">Clicks</h5>
                            <input class="form-check-input me-1 cursor-pointer" type="checkbox" name="keyWord"
                                [checked]="totalClicks">
                        </div>
                        <p class="card-text">{{gscData[0]?.clicks ? gscData[0]?.clicks : 0}}</p>
                        <!-- <p class="card-text"><small class="text-muted">+20.1% from last month</small></p> -->
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card text-start" role="button" (click)="totalImpressions =! totalImpressions;showChart()"
                    [ngClass]="!!totalImpressions ? 'active-impression border-0' : ''">
                    <div class="card-body">
                        <div class="d-flex justify-content-between">
                            <h5 class="card-title fw-bold fs-6">Impression</h5>
                            <input class="form-check-input me-1 cursor-pointer" type="checkbox" name="keyWord"
                                [checked]="totalImpressions">
                        </div>
                        <p class="card-text">{{gscData[0]?.impressions ? gscData[0]?.impressions : 0}}</p>
                        <!-- <p class="card-text"><small class="text-muted">+180.1% from last month</small></p> -->
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card text-start" role="button" (click)="avgCtr =! avgCtr;showChart()"
                    [ngClass]="!!avgCtr ? 'active-ctr border-0' : ''">
                    <div class="card-body">
                        <div class="d-flex justify-content-between">
                            <h5 class="card-title fw-bold fs-6">Average CTR</h5>
                            <input class="form-check-input me-1 cursor-pointer" type="checkbox" name="keyWord"
                                [checked]="avgCtr">
                        </div>
                        <p class="card-text">{{showDecimals(gscData[0]?.ctr)}}</p>
                        <!-- <p class="card-text"><small class="text-muted">+19% from last month</small></p> -->
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card text-start" role="button" (click)="avgPosition =! avgPosition;showChart()"
                    [ngClass]="!!avgPosition ? 'active-position border-0' : ''">
                    <div class="card-body">
                        <div class="d-flex justify-content-between">
                            <h5 class="card-title fw-bold fs-6">Average Position</h5>
                            <input class="form-check-input me-1 cursor-pointer" type="checkbox" name="keyWord"
                                [checked]="avgPosition">
                        </div>
                        <p class="card-text">{{getPosition(this.gscData[0]?.position)}}</p>
                        <!-- <p class="card-text"><small class="text-muted">+201 since last hour</small></p> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container mt-3">
        <div class="col-md-12">
            <div class="card text-start">
                <div class="card-body">
                    <div class="">
                        <div>
                            <canvas id="canvas" style="width: 100%; height: 20em;"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container my-3">
        <div class="col-md-12">
            <div class="card text-start">
                <div class="card-body">
                    <div class="d-flex justify-content-between">
                        <div class="tab-page">
                            <ul class="nav nav-pills">
                                <li class="nav-item" (click)="changeActiveLink('QUERY')">
                                    <a class="nav-link text-decoration-none"
                                        [ngClass]="activeLink=='QUERY' ? 'active' : ''">Queries</a>
                                </li>
                                <li class="nav-item" (click)="changeActiveLink('PAGE')">
                                    <a class="nav-link text-decoration-none"
                                        [ngClass]="activeLink=='PAGE' ? 'active' : ''">Pages</a>
                                </li>
                                <li class="nav-item" (click)="changeActiveLink('COUNTRY')">
                                    <a class="nav-link text-decoration-none"
                                        [ngClass]="activeLink=='COUNTRY' ? 'active' : ''">Countries</a>
                                </li>
                                <li class="nav-item" (click)="changeActiveLink('DEVICE')">
                                    <a class="nav-link text-decoration-none"
                                        [ngClass]="activeLink=='DEVICE' ? 'active' : ''">Devices</a>
                                </li>
                                <li class="nav-item" (click)="changeActiveLink('SEARCH_APPEARANCE')">
                                    <a class="nav-link text-decoration-none"
                                        [ngClass]="activeLink=='SEARCH_APPEARANCE' ? 'active' : ''">Search
                                        Appearance</a>
                                </li>
                                <li class="nav-item" (click)="changeActiveLink('DATE')">
                                    <a class="nav-link text-decoration-none"
                                        [ngClass]="activeLink=='DATE' ? 'active' : ''">Dates</a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <div class="btn-group me-2" role="group" aria-label="Basic example"
                                *ngIf="activeLink=='QUERY'">
                                <button class="btn btn-outline-primary py-1 px-2 text-nowrap"
                                    [disabled]="queryyData?.length===0 || (userData?.kw_max_credit - userData?.kw_credit ==0)"
                                    (click)="openModal('lckr')">
                                    Import To LCKR
                                </button>
                                <button class="btn btn-outline-primary py-1 px-2" [matMenuTriggerFor]="SelectKeywords"
                                    container="body" triggers="mouseenter:mouseleave">
                                    <i class="mt-1 bi bi-chevron-down me-1"></i>
                                </button>
                            </div>
                            <mat-menu #SelectKeywords>
                                <div class="curr_page">
                                    <!-- <input class="form-check-input" type="checkbox" (change)="checkAll()" [(ngModel)]="masterSelected" [disabled]="!!allSelect"> -->
                                    <!-- <label style="padding-left:6px;padding-bottom:6px;">Current Page</label><br> -->
                                    <button mat-menu-item (click)="pageSelection('current')">Current page</button>
                                    <button mat-menu-item (click)="pageSelection('all')">All pages</button>
                                    <!-- <input class="form-check-input" type="checkbox"  role="button"  (change)="allPageSelect()"
                                  [(ngModel)]="allSelect"> -->
                                    <!-- <label style="padding-left:6px;padding-bottom:6px;">All pages</label> -->
                                </div>
                            </mat-menu>
                            <!-- <button class="btn btn-outline-primary me-1" (click)="openModal('lckr')"
                                *ngIf="activeLink=='QUERY'" >Import To LCKR</button> -->
                            <button class="btn btn-outline-primary" (click)="openModal('ce')"
                                *ngIf="activeLink=='QUERY'"
                                [disabled]="queryyData?.length===0 || (totalCredits - remainingCredits==0)">Create
                                Content
                                Editor</button>
                            <button class="btn btn-outline-primary" (click)="openModal('audit')"
                                *ngIf="activeLink=='PAGE'"
                                [disabled]="queryyData?.length===0 || (totalAuditCredits - remainingAuditCredits==0)">Create
                                Audit</button>
                        </div>
                        <ng-template #importKeywords let-modal>

                            <div class="p-4">
                                <div class="position-relative heading-border pb-3">
                                    <h1 class="fw-bold m-0 heading">Import keywords</h1>
                                    <button type="button" class="position-absolute top-0 end-0 btn-close"
                                        aria-label="Close" (click)="closeModal()">
                                        <i class="bi bi-x-lg fw-bold text-white" *ngIf="!theme"></i>
                                    </button>
                                </div>
                                <div class="overflow-content">
                                    <div class="mt-3">
                                        <div class="country-box">
                                            <div class="col-12 mb-3">
                                                <label class="fw-600 fs-14">Country</label><br>
                                                <mat-form-field appearance="outline"
                                                    class="w-100 country-input flag-input"
                                                    [ngClass]="theme ? '': 'dark-input' ">
                                                    <img [src]="importselectedFlag !=='' ? importselectedFlag : importdefaultFlag"
                                                        alt="" width="34" height="24" class="selected-flag">
                                                    <mat-select [(ngModel)]="importSelected"
                                                        [disableOptionCentering]="true" panelClass="{{selectMenu}}">
                                                        <div class="p-2">
                                                            <input type="text" class="form-control input"
                                                                placeholder="Search ..."
                                                                (keyup)="searchDropDownData($event,'country')">
                                                        </div>
                                                        <mat-option *ngFor="let data of dropDownCountry"
                                                            (click)="getSelectedFlag(data.code.toLowerCase(),data?.name,'lckr')"
                                                            [value]="data.code.toLowerCase()">
                                                            <img loading="lazy"
                                                                src="https://flagpedia.net/data/flags/normal/{{data.code.toLowerCase()}}.png"
                                                                alt="" width="34" height="24">
                                                            <span class="fs-16 ms-2 ps-1">{{data?.name}}</span>
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-12 mb-3">
                                                <label class="fw-600 fs-14">Language</label>
                                                <mat-form-field appearance="outline" class="w-100 country-input"
                                                    [ngClass]="theme ? '': 'dark-input' ">
                                                    <mat-select [(ngModel)]="importlanguageType"
                                                        panelClass="{{selectMenu}}" [disableOptionCentering]="true">
                                                        <div class="p-2">
                                                            <input type="text" class="form-control input"
                                                                placeholder="Search ..."
                                                                (keyup)="searchDropDownData($event,'language')">
                                                        </div>
                                                        <mat-option *ngFor="let data of languageDropdown"
                                                            (click)="languageType===data.code"
                                                            [value]="data.code">{{data.name}}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>

                                            </div>
                                        </div>
                                        <div class="col-12 mt-3">
                                            <label class="fw-600 fs-14">Report Name</label>
                                            <input type="text" name="reportName" id="reportName"
                                                [(ngModel)]="reportName" class="input col-12 form-control" />
                                            <div>
                                                <span id="reportErr" class="error-font"
                                                    *ngIf="!!isSubmitted && reportName ===''">ReportName is
                                                    required</span>
                                            </div>
                                        </div>
                                        <div class="col-12 mt-3">
                                            <label class="fw-600 fs-14">Enter/Paste Keyword one per line</label>
                                            <textarea name="reportData" id="reportData" rows="4"
                                                class="input h-auto col-12 form-control"
                                                [(ngModel)]="reportData"></textarea>
                                            <div>
                                                <span id="reportDataErr" class="error-font"
                                                    *ngIf="!!isSubmitted && reportData ===''">ReportData is
                                                    required</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex mt-4 justify-content-end">
                                    <button class="btn btn-outline-primary me-1 px-5" id="reportBtn"
                                        (click)="createReport()" [disabled]="reportName===''">Create
                                        Report</button>
                                </div>
                            </div>
                        </ng-template>
                    </div>

                    <!-- <div class="border-bottom-2">
                            <div class="mt-4 col-6">
                                <div class="d-flex align-items-center">
                                    <div class="col-3 text-center  NeutralLight fw-600 dull-neutral pb-1" role="button" (click)="changeActiveLink('QUERY')" [ngClass]="activeLink=='QUERY' ? 'active-tab' : 'border-bottom-2'">
                                        <p class="m-0">Queries</p>
                                    </div>
                                    <div class="col-3 text-center  NeutralLight fw-600 dull-neutral pb-1" role="button" (click)="changeActiveLink('PAGE')" [ngClass]="activeLink=='PAGE' ? 'active-tab' : 'border-bottom-2'">
                                        <p class="m-0">Pages</p>
                                    </div>
                                    <div class="col-3 text-center NeutralLight fw-600 dull-neutral pb-1" role="button" (click)="changeActiveLink('COUNTRY')" [ngClass]="activeLink=='COUNTRY' ? 'active-tab' : 'border-bottom-2'">
                                        <p class="m-0">Countries</p>
                                    </div>
                                    <div class="col-3 text-center  NeutralLight fw-600 dull-neutral pb-1" role="button" (click)="changeActiveLink('DEVICE')" [ngClass]="activeLink=='DEVICE' ? 'active-tab' : 'border-bottom-2'">
                                        <p class="m-0">Devices</p>
                                    </div>
                                    <div class="col-3 text-center  NeutralLight fw-600 dull-neutral pb-1" role="button"(click)="changeActiveLink('SEARCH_APPEARANCE')" [ngClass]="activeLink=='SEARCH_APPEARANCE' ? 'active-tab' : 'border-bottom-2'">
                                        <p class="m-0">Search Appearance</p>
                                    </div>
                                    <div class="col-3 text-center NeutralLight fw-600 dull-neutral pb-1" role="button"(click)="changeActiveLink('DATE')" [ngClass]="activeLink=='DATE' ? 'active-tab' : 'border-bottom-2'">
                                        <p class="m-0">Dates</p>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    <div class="mt-5">
                        <div class="text-center">
                            <div class="spinner-border text-primary" role="status" style="height: 40px;width: 40px;border-width: 5px;" *ngIf="loading">
                            </div>
                        </div>
                        <table class="table" *ngIf="!loading && queryData.length > 0">
                            <thead>
                                <tr>
                                    <!-- <th scope="col" class="text-secondary ps-3" style="width: 40px;"></th> -->
                                    <th scope="col" role="button" class="d-flex">
                                        <!-- <input class="form-check-input me-2"
                                        type="button" placement="bottom" [ngbPopover]="SelectKeywords" popoverClass="{{popover}}"
                                        role="button" container="body"> -->
                                        <!-- <input class="form-check-input me-1" type="checkbox" name="keyWord"> -->
                                        <div class="d-flex" (click)="sortTable('query')">
                                            <p class="m-0 me-2">Query </p>
                                            <i class="bi bi-arrow-up" *ngIf="queryUparrow"></i>
                                            <i class="bi bi-arrow-down" *ngIf="queryDownarrow"></i>
                                        </div>
                                    </th>
                                    <th scope="col" role="button">
                                        <div class="d-flex" (click)="sortTable('click')">
                                            <p class="m-0 me-2">Clicks </p>
                                            <i class="bi bi-arrow-up" *ngIf="clickUpArrow"></i>
                                            <i class="bi bi-arrow-down" *ngIf="clickDownArrow"></i>
                                        </div>
                                    </th>
                                    <th scope="col" role="button">
                                        <div class="d-flex" (click)="sortTable('impressions')">
                                            <p class="m-0 me-2">Impressions </p>
                                            <i class="bi bi-arrow-up" *ngIf="impressionUpArrow"></i>
                                            <i class="bi bi-arrow-down" *ngIf="impressionDownArrow"></i>
                                        </div>
                                    </th>
                                    <th scope="col" role="button">
                                        <div class="d-flex" (click)="sortTable('ctr')">
                                            <p class="m-0 me-2">CTR </p>
                                            <i class="bi bi-arrow-up" *ngIf="ctrUpArrow"></i>
                                            <i class="bi bi-arrow-down" *ngIf="ctrDownArrow"></i>
                                        </div>
                                    </th>
                                    <th scope="col" role="button">
                                        <div class="d-flex" (click)="sortTable('position')">
                                            <p class="m-0 me-2">Position </p>
                                            <i class="bi bi-arrow-up" *ngIf="positionUpArrow"></i>
                                            <i class="bi bi-arrow-down" *ngIf="positionDownArrow"></i>
                                        </div>
                                    </th>
                                    <!-- <th scope="col">Clicks Growth</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Strell Doc</th> -->
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let data of queryData">
                                    <th scope="row">
                                        <div class="d-flex">
                                            <ng-container *ngIf="activeLink==='QUERY' || activeLink==='PAGE'">
                                                <input class="form-check-input me-1 cursor-pointer" type="checkbox"
                                                    name="keyWord" role="button"
                                                    *ngIf="activeLink==='QUERY' || activeLink==='PAGE'"
                                                    [(ngModel)]="data.isChecked" (change)="changeKeyword()">
                                            </ng-container>
                                            <p>{{data?.keys[0]}}</p>
                                        </div>
                                    </th>
                                    <td>{{data?.clicks}}</td>
                                    <td>{{data?.impressions}}</td>
                                    <td>{{showDecimals(data?.ctr)}}</td>
                                    <td>{{getPosition(data?.position)}}</td>
                                    <!-- <td>-</td>
                                    <td>
                                        <div class="border border-1 border-grey rounded"
                                            style="background: rgb(248, 192, 118)">
                                            <p class="p-2 m-0 text-center">Opportunity</p>
                                        </div>
                                    </td>
                                    <td>+</td> -->
                                </tr>
                            </tbody>
                        </table>


                        <div class="col-12 d-flex justify-content-end" *ngIf="!loading && queryData.length > 0">
                            <ngb-pagination [collectionSize]="queryData?.length > 0 ? backupGscData.length : 0"
                                [maxSize]="3" [(page)]="page" [pageSize]="tableSize" [rotate]="true"
                                (pageChange)="onTableDataChange()"></ngb-pagination>
                        </div>
                        <div class="" *ngIf="!loading && queryData.length == 0">
                            <p class="text-center">No Data Available</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <ng-template #callAPIDialog>
        <h2 mat-dialog-title>Date range</h2>
        <mat-dialog-content class="mat-typography">
            <mat-radio-group class="d-flex flex-column" [(ngModel)]="date">
                <mat-radio-button value="7" class="mt-3 " *ngFor="let btn of radioArr" [value]="btn.value">{{btn.text}}</mat-radio-button>
            </mat-radio-group>
            <div class="col-md-10 container-fluid d-flex justify-content-between mt-3" *ngIf="date=='custom'">
                <mat-form-field class="col-md-5 mt-1" appearance="outline" >
                    <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate" placeholder="Choose a startdate" [(ngModel)]="customStartDate">
                    <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon>event</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker>
                    </mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-md-5 mt-1" appearance="outline">
                    <input matInput [matDatepicker]="picker1" [min]="minDate" [max]="maxDate" placeholder="Choose a enddate" [(ngModel)]="customEndDate">
                    <mat-datepicker-toggle matSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon>event</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker1>
                    </mat-datepicker>
                </mat-form-field>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions class="justify-content-end">
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-button color="primary" (click)="onApply()">Apply</button>
        </mat-dialog-actions>
    
    </ng-template> -->

    <ng-template #content let-modal>
        <div class="modal-header">
            <h4 class="modal-title p-0 m-0" id="modal-basic-title">Date range</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <mat-radio-group class="d-flex flex-column" [(ngModel)]="date">
                <mat-radio-button value="7" class="mt-3 " *ngFor="let btn of radioArr"
                    [value]="btn.value">{{btn.text}}</mat-radio-button>
            </mat-radio-group>
            <div class="col-md-10 container-fluid d-flex justify-content-between mt-3" *ngIf="date=='custom'">
                <mat-form-field class="col-md-5 mt-1" appearance="outline">
                    <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                        placeholder="Choose a startdate" [(ngModel)]="customStartDate">
                    <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon>event</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker>
                    </mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-md-5 mt-1" appearance="outline">
                    <input matInput [matDatepicker]="picker1" [min]="minDate" [max]="maxDate"
                        placeholder="Choose a enddate" [(ngModel)]="customEndDate">
                    <mat-datepicker-toggle matSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon>event</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker1>
                    </mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="modal-footer">
            <button mat-button (click)="modal.close()">Cancel</button>
            <button mat-button color="primary" (click)="onApply()">Apply</button>
            <!-- <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button> -->
        </div>
    </ng-template>
    <ng-template #filter let-modal>
        <div class="modal-header">
            <h4 class="modal-title p-0 m-0" id="modal-basic-title">{{activeFilterTitle}}</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <ng-container *ngIf="activeFilterTitle=='QUERY'">
            <div class="modal-body">
                <div class="col-12">
                    <mat-form-field appearance="outline" class="col-5 country-input flag-input"
                        [ngClass]="theme ? '': 'dark-input' ">
                        <mat-select [(ngModel)]="selectedQuery" (selectionChange)="changeQueryData($event)"
                            panelClass="{{selectMenu}}">
                            <mat-option value="CONTAINS">Queries containing</mat-option>
                            <mat-option value="NOT_CONTAINS">Queries not containing</mat-option>
                            <mat-option value="EQUALS">Exact query</mat-option>
                            <mat-option value="CUSTOM">Custom(regex)</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" *ngIf="selectedQuery==='CUSTOM'"
                        class=" ms-2 col-5 country-input flag-input" [ngClass]="theme ? '': 'dark-input' ">
                        <mat-select [(ngModel)]="selectedCustomQuery" (selectionChange)="changeCustomQueryData($event)"
                            panelClass="{{selectMenu}}">
                            <mat-option value="INCLUDING_REGEX" selected>Matches regex</mat-option>
                            <mat-option value="EXCLUDING_REGEX">Doesn't match regex</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <input type="text" class="form-control input ps-56 mt-2" style="height: 3em;" [(ngModel)]="queryTitle"
                    [placeholder]="selectedQuery==='CUSTOM' ? 'Enter custom regex' : 'Keyword'">
            </div>
        </ng-container>
        <ng-container *ngIf="activeFilterTitle=='PAGE'">
            <div class="modal-body">
                <div class="col-12">
                    <mat-form-field appearance="outline" class="col-5 country-input flag-input"
                        [ngClass]="theme ? '': 'dark-input' ">
                        <mat-select [(ngModel)]="selectedQuery" (selectionChange)="changeQueryData($event)"
                            panelClass="{{selectMenu}}">
                            <mat-option value="CONTAINS">URLs containing</mat-option>
                            <mat-option value="NOT_CONTAINS">URLs not containing</mat-option>
                            <mat-option value="EQUALS">Exact URL</mat-option>
                            <mat-option value="CUSTOM">Custom(regex)</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" *ngIf="selectedQuery==='CUSTOM'"
                        class=" ms-2 col-5 country-input flag-input" [ngClass]="theme ? '': 'dark-input' ">
                        <mat-select [(ngModel)]="selectedCustomQuery" (selectionChange)="changeCustomQueryData($event)"
                            panelClass="{{selectMenu}}">
                            <mat-option value="INCLUDING_REGEX" selected>Matches regex</mat-option>
                            <mat-option value="EXCLUDING_REGEX">Doesn't match regex</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <input type="text" class="form-control input ps-56 mt-2" style="height: 3em;" [(ngModel)]="queryUrl"
                    [placeholder]="selectedQuery==='CUSTOM' ? 'Enter custom regex' : 'http://www.example.com'">
            </div>
        </ng-container>
        <ng-container *ngIf="activeFilterTitle=='DEVICE'">
            <div class="modal-body">
                <mat-radio-group class="d-flex flex-column" [(ngModel)]="selectedDevice">
                    <mat-radio-button class="mt-3 " value="DESKTOP">Desktop</mat-radio-button>
                    <mat-radio-button class="mt-3 " value="MOBILE">Mobile</mat-radio-button>
                    <mat-radio-button class="mt-3 " value="TABLET">Tablet</mat-radio-button>
                </mat-radio-group>

            </div>
        </ng-container>
        <ng-container *ngIf="activeFilterTitle=='COUNTRY'">
            <div class="modal-body" style="height:450px;overflow: scroll;">
                <mat-radio-group class="d-flex flex-column" [(ngModel)]="selectedGscCountry">
                    <mat-radio-button value="7" class="mt-3 " *ngFor="let btn of gscCountries"
                        [value]="btn.code">{{btn.name}}</mat-radio-button>
                </mat-radio-group>
            </div>
        </ng-container>

        <div class="modal-footer">
            <button mat-button (click)="modal.close()">Cancel</button>
            <button mat-button color="primary" (click)="onQueryApply()"
                *ngIf="activeFilterTitle=='PAGE' || activeFilterTitle=='QUERY'"
                [disabled]="queryTitle==''">Apply</button>
            <button mat-button color="primary" (click)="onQueryApply()"
                *ngIf="activeFilterTitle=='COUNTRY' || activeFilterTitle=='DEVICE'">Apply</button>
            <!-- <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button> -->
        </div>
    </ng-template>

</div>

<!-- </div> -->